import {
  IconBuilding,
  IconCalendar,
  IconCard,
  IconClubs,
  IconFlag,
  IconLeaderboard,
  IconMessage,
  IconPokerChip,
  IconReport,
  IconSettings,
  IconUsers,
} from '@ui/icons'

export type NavItem = {
  to: string
  labelKey: string
  shortLabelKey: string
  Icon: typeof IconCalendar
  exact?: boolean
}

export const ACCOUNT_NAV: NavItem[] = [
  {
    to: '/events',
    labelKey: 'nav.events',
    shortLabelKey: 'nav-short.events',
    Icon: IconCalendar,
  },
  {
    to: '/users',
    labelKey: 'nav.users',
    shortLabelKey: 'nav-short.users',
    Icon: IconUsers,
  },
  {
    to: '/account-settings',
    labelKey: 'nav.account-settings',
    shortLabelKey: 'nav-short.account',
    Icon: IconSettings,
  },
]

// Read-only course catalogue for non-platform accounts (tenants, future B2C).
// Platform members manage the catalog at /platform/courses instead — the two
// items share labels because no account ever sees both.
export const CATALOGUE_NAV_ITEM: NavItem = {
  to: '/courses',
  labelKey: 'nav.courses',
  shortLabelKey: 'nav-short.courses',
  Icon: IconClubs,
}

export const PLATFORM_NAV: NavItem[] = [
  {
    to: '/platform/accounts',
    labelKey: 'nav.accounts',
    shortLabelKey: 'nav.accounts',
    Icon: IconBuilding,
  },
  {
    to: '/platform/users',
    labelKey: 'nav.platform-users',
    shortLabelKey: 'nav.platform-users',
    Icon: IconUsers,
  },
  {
    to: '/platform/courses',
    labelKey: 'nav.courses',
    shortLabelKey: 'nav-short.courses',
    Icon: IconClubs,
  },
  {
    to: '/platform/vipps-payments',
    labelKey: 'nav.vipps-payments',
    shortLabelKey: 'nav.vipps-payments',
    Icon: IconCard,
  },
  {
    to: '/platform/sms',
    labelKey: 'nav.sms',
    shortLabelKey: 'nav.sms',
    Icon: IconMessage,
  },
  {
    to: '/platform/reports',
    labelKey: 'nav.reports',
    shortLabelKey: 'nav.reports',
    Icon: IconReport,
  },
]

export const EVENT_NAV = (eventId: string, mode?: string | null): NavItem[] => {
  // Poker-only (POKER) events are operational, not golf: the Poker page is the
  // home and runs the whole flow — players, config, draw, clock — inline. No
  // golf summary, no flights, no separate players tab. A lean rail: Poker →
  // Settings.
  if (mode === 'POKER') {
    return [
      {
        to: `/events/${eventId}/poker`,
        labelKey: 'nav.event-poker',
        shortLabelKey: 'nav-short.poker',
        Icon: IconPokerChip,
      },
      {
        to: `/events/${eventId}/settings`,
        labelKey: 'nav.event-settings',
        shortLabelKey: 'nav-short.settings',
        Icon: IconSettings,
      },
    ]
  }

  const items: NavItem[] = [
    {
      to: `/events/${eventId}/summary`,
      labelKey: 'nav.event-summary',
      shortLabelKey: 'nav-short.summary',
      Icon: IconLeaderboard,
    },
    {
      to: `/events/${eventId}/players`,
      labelKey: 'nav.event-players',
      shortLabelKey: 'nav-short.players',
      Icon: IconUsers,
    },
  ]
  items.push({
    to: `/events/${eventId}/flights`,
    labelKey: 'nav.event-flights',
    shortLabelKey: 'nav-short.flights',
    Icon: IconFlag,
  })
  if (mode === 'POLF') {
    items.push({
      to: `/events/${eventId}/poker`,
      labelKey: 'nav.event-poker',
      shortLabelKey: 'nav-short.poker',
      Icon: IconPokerChip,
    })
  }
  items.push({
    to: `/events/${eventId}/settings`,
    labelKey: 'nav.event-settings',
    shortLabelKey: 'nav-short.settings',
    Icon: IconSettings,
  })
  return items
}
